import {Component, Input} from '@angular/core';
import {Artist} from '../../model/Artist';
import { AlbumSummaryCollection } from 'src/app/model/AlbumSummaryCollection';

@Component({
  selector: 'app-albums-card',
  templateUrl: './albums-card.component.html',
  styleUrls: ['./albums-card.component.scss']
})
export class AlbumsCardComponent {

  @Input()
  artist: Artist;

  @Input()
  albums: AlbumSummaryCollection;

}
